import { usePublish, useView } from '@10000/react'
import { Body, Box, Card, H3 } from '../../widgets'
import { assetUrl } from '../../../utilities.js'
import { expertise, indexFromValue } from '../../../lookups'
import './ComparisonCards.scss'

export const ComparisonCards = ({ displayMode, ...props }) => {
  const publish = usePublish('squiz')
  const { question, teamAverages, consensusAnswers, result, highlightedResult, presenter } = useView('squiz')
  const teamAverage = teamAverages[question]
  const consensus = consensusAnswers?.[0]?.answer
  const selectQuestionResult = index => () => publish('resultHighlighted', { index })

  return <>
    <Instructions className="mobile-only" />
    <Box
      fullWidth
      fullHeight
      gap={8}
      display={typeof consensus === 'number' ? 'flex' : 'none'}
      className="comparison-cards"
      {...props}
    >
      <ComparisonCard
        id="team-average-card"
        background={highlightedResult === 0 && `url(${assetUrl(`backgrounds/card-1.png`)}) 28% 38% / 172%`}
        title={<>Standard<br/>mode</>}
        rotate={-2}
        value={teamAverage}
        displayMode={displayMode}
        selected={highlightedResult === 0}
        onClick={presenter && selectQuestionResult(0)}
      />
      <Instructions className="desktop-only" visible={result === 'consensus' && !displayMode} />
      <ComparisonCard
        id="consensus-card"
        background={highlightedResult === 1 && `url(${assetUrl(`backgrounds/card-2.png`)}) 0 35% / 172%`}
        title={<>Consensus<br/>mode</>}
        rotate={2.5}
        value={consensus}
        displayMode={displayMode}
        selected={highlightedResult === 1}
        onClick={presenter && selectQuestionResult(1)}
      />
    </Box>
  </>
}

const Instructions = ({ className, visible }) => (
  <Box className={`instructions ${className}`} opacity={visible ? 1 : 0} transition="opacity 0.5s">
    <Body fullWidth bold={false} align="center">
      Click on <b>STANDARD MODE</b> or<br/><b>CONSENSUS MODE</b> to highlight score
    </Body>
  </Box>
)

const ComparisonCard = ({ id, background, title, rotate, value, displayMode, selected, onClick }) => (
  <Box
    container
    fullHeight
    top="100%"
    id={id}
  >
    <Card
      background={background}
      selected={selected}
      onClick={displayMode ? undefined : onClick}
      column
      rotate={rotate}
      p={8}
      gap={displayMode ? 32 : 16}
      shadow={false}
    >
      <Body
        alt
        align="center"
        uppercase
      >
        {title}
      </Body>

      <H3 uppercase>
        {expertise[indexFromValue(value)]}
      </H3>
    </Card>
  </Box>
)